import { GIT_INTEGRATION_BASE_PATH } from '../consts';
import { getServerUrl } from '../utils';

export const BASE_URL = `${getServerUrl()}${GIT_INTEGRATION_BASE_PATH}`;
